import React from 'react';
import getConfig from 'next/config';

import {Tenant} from '~/src/utilities/constants/tenant';

import css from '~/src/css/global.module.scss';

const {publicRuntimeConfig: config} = getConfig();

const ShareLink = ({title}) => (
    <svg viewBox="0 0 18 18">
        {title && <title>{title}</title>}
        <g id="Front-Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Front-Desktop_share"
                transform="translate(-771.000000, -602.000000)"
                fill={config.tenantId === Tenant.LEMATIN ? css.colorTango : css.accentColor}
            >
                <g id="Group-2" transform="translate(0.000000, -7.000000)">
                    <g id="Group-7" transform="translate(747.000000, 252.000000)">
                        <g id="Link-kopieren" transform="translate(0.000000, 331.000000)">
                            <path
                                d="M34.8630349,31.5531641 C35.1786438,31.7453617 35.4778533,31.9765987 35.7505038,32.2500352 C37.5988791,34.0984117 37.599659,37.1069333 35.7505038,38.9553497 L35.7505038,38.9553497 L32.0928318,42.613103 C30.2436966,44.462299 27.2352419,44.462299 25.3868666,42.613103 C23.5377111,40.7639266 23.5377111,37.755405 25.3868666,35.9069886 L25.3868666,35.9069886 L27.9211179,33.3726809 C27.7250447,34.4726669 27.8469005,35.6194922 28.2914249,36.6632389 L28.2914249,36.6632389 L27.2164625,37.7374452 C26.375872,38.5780345 26.375872,39.945197 27.2164625,40.7858063 C28.0570331,41.6264156 29.4241653,41.6264156 30.2647558,40.7858063 L30.2647558,40.7858063 L33.9224278,37.128053 C34.7630184,36.2874637 34.7630184,34.9203012 33.9224278,34.0796919 C33.631818,33.7890756 33.2779303,33.6008 32.9052834,33.5117391 L32.9052834,33.5117391 Z M33.9071683,27.3868973 C35.7563036,25.5377009 38.7647583,25.5377009 40.6131336,27.3868973 C42.4622888,29.2352737 42.4622888,32.2437953 40.6131336,34.0922117 L40.6131336,34.0922117 L38.0788823,36.6272994 C38.2749554,35.5273134 38.1530797,34.3804881 37.7101352,33.3375414 L37.7101352,33.3375414 L38.7843176,32.2625551 C39.6249081,31.4219658 39.6249081,30.0548033 38.7843176,29.214194 C37.943747,28.3735847 36.5766149,28.3735847 35.7360243,29.214194 L35.7360243,29.214194 L32.0783523,32.8719473 C31.2377618,33.7125366 31.2377618,35.0796991 32.0783523,35.9203084 C32.3689622,36.2109247 32.7228498,36.3992003 33.0954967,36.4882612 L33.0954967,36.4882612 L31.1377453,38.4468362 C30.8213563,38.2546386 30.5221468,38.0234016 30.2494964,37.7499651 C28.4003411,35.9015886 28.4003411,32.893067 30.2494964,31.0446506 L30.2494964,31.0446506 Z"
                                id="Combined-Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ShareLink;
